import queryString from 'query-string';

export class SearchSerializer {
  public static stringify(searchObject: Record<string, unknown>): string {
    const simplifiedSearch = {
      ...searchObject,
    };

    const output = queryString.stringify(simplifiedSearch, {
      arrayFormat: 'bracket-separator',
    });

    return output ? `?${output}` : '';
  }

  public static parse(searchString: string): Record<string, unknown> {
    const {
      selection: simplifiedTypeSelection,
      feature: simplifiedFeatureIdentifier,
      ...simplifiedOutput
    } = queryString.parse(searchString, {
      arrayFormat: 'bracket-separator',
      parseBooleans: true,
      parseNumbers: true,
    });

    return {
      ...simplifiedOutput,
    };
  }
}
